import {
    Component,
    ElementRef,
    OnInit,
    ViewChild
} from '@angular/core';
import {
    IProduct,
    Product
} from '../model/product';
import {
    IReservation,
    Reservation
} from '../model/reservation';
import { IError } from '../model/types';
import { Payment } from '../model/payment';
import {
  Router
} from '@angular/router';
import { Contact } from '../model/contact';
import { ReCaptchaComponent } from 'angular2-recaptcha';

const moment = require('../../../../node_modules/moment/moment.js');
const _ = require('../../../../node_modules/lodash/index');

@Component({
    selector: 'order-component',
    template: require('./order.component.html'),
    styles: [require('./order.component.css')]
})

export class OrderComponent implements OnInit {

    @ViewChild(ReCaptchaComponent) private captcha: ReCaptchaComponent;
    @ViewChild('orderRows') public orderRows : ElementRef;

    public formSent : boolean = false;
    public products : Array<{label: string, items: IProduct[]}> = [];
    public selectedItem : IProduct;
    public editingReservation : IReservation = null;
    public errors : {errors: IError[]};
    public vatPc = 24;
    public showTerms : boolean;

    public reservationTimes = [
        {type: 'TIME_MORNING', label: 'Aamu'},
        {type: 'TIME_EVENING', label: 'Ilta'}
    ];

    private productMap : {
        '2h': {label: string, items: IProduct[]},
        '4h': {label: string, items: IProduct[]},
        'pv': {label: string, items: IProduct[]},
        'vkl': {label: string, items: IProduct[]},
        'paketti': {label: string, items: IProduct[]}
    } = {
        '2h': {label: '2h', items: []},
        '4h': {label: '4h', items: [null]},
        'pv': {label: 'Päivä', items: [null]},
        'vkl': {label: 'Vkl', items: [null]},
        'paketti': {label: 'Paketti', items: []}
    };

    private checkboxMemory : any;

    public constructor(
        private ProductResource : Product,
        private ReservationResource: Reservation,
        private PaymentResource: Payment,
        private router: Router,
        private ContactResource : Contact
    ) {}

    public urlChange() {
        const url = this.router.routerState.snapshot.url.substr(2,100);
        const i = {
          'taysihoito-1': 0,
          'tee-se-itse-1': 1,
          'taysihoito-2': 2,
          'tee-se-itse-2': 3
        }[url];

        this.select(this.productMap.paketti.items[i]);
    }
    public ngOnInit() {

        this.router.events.subscribe(() => this.urlChange());

        this.editingReservation = Reservation.newReservation(new Date());
        this.ProductResource.query()
            .$observable
            .subscribe((products : IProduct[]) => {
                for (let product of products)
                {
                    let hours = product.hours,
                        label = 'Tuntivuokra ' + product.hours + 'h',
                        info = ' (8:00 - 21:00)';
                    if (product.type === 'TYPE_DAY') {
                        product.hours = 12;
                        label = 'Päivävuokra';
                        info = '(8:00 - 20:00)';
                    } else if (product.type === 'TYPE_WEEKEND') {
                        product.hours = 52;
                        label = 'Viikonloppuvuokra';
                        info = '(pe 8:00 - su 12:00)';
                    } else if (product.type === 'TYPE_BUNDLE') {
                        info = '';
                        label = {1: 'TÄYSIHOITO 1h', 2: 'TÄYSIHOITO 2h', 4: 'TEE SE ITSE 4h', 8: 'TEE SE ITSE 8h'}[product.hours];
                        product.colspan = 2;
                    }

                    product.perPerson = product.price / product.balls;
                    product.perPersonPerHour = product.price / product.balls / product.hours;
                    product.label = label;
                    product.info = info;
                    this.productMap[product.name].items.push(product);
                }
                this.products.push(this.productMap['2h']);
                this.products.push(this.productMap['4h']);
                this.products.push(this.productMap['pv']);
                this.products.push(this.productMap['vkl']);
                this.products.push(this.productMap['paketti']);

                this.urlChange();
            });
    }

    public select(item: IProduct) {
        if (!item) {
            return;
        }
        this.selectedItem = item;
        this.editingReservation.balls = item.balls;
        this.editingReservation.pumps = item.pumps;
        this.editingReservation.hours = item.hours;
        this.editingReservation.type = item.type;
        this.editingReservation.time = 'TIME_MORNING';
        this.editingReservation.canReserve = false;

        const map = {
            1: 'taysihoito-1',
            4: 'tee-se-itse-1',
            2: 'taysihoito-2',
            8: 'tee-se-itse-2'
        };
        for(let id in map) {
           document.getElementById('ul_' + map[id]).className = '';
        }

        if (item.type === 'TYPE_BUNDLE') {
          this.editingReservation.staff = item.hours < 4;
          this.editingReservation.delivery = item.hours < 4;
          this.editingReservation.pickUp = item.hours < 4;

          document.getElementById('ul_' + map[item.hours]).className = 'selected';

        }
    }

    public check(reservation: IReservation) {
        let copy = Object.assign({}, reservation);
        copy.startDate = copy.startDate && moment(copy.startDate).format('YYYY-MM-DD');

        this.ReservationResource.check(copy)
            .$observable
            .subscribe((response : {status: string}) => {
                console.log(status, reservation);
                if (response.status === 'ok') {
                    reservation.canReserve = true;

                    console.log(reservation, reservation.canReserve);
                }

                this.errors = null;

                reservation.order = {id: null, rows: [], invoices: [], total: 0};
                let times = {TIME_MORNING: 'Aamu', TIME_EVENING: 'Ilta'};
                reservation.order.rows.push({
                    id: null,
                    name: reservation.balls + ' palloa ' + this.selectedItem.label,
                    price: this.selectedItem.price * 100
                });

                reservation.order.total = this.selectedItem.price * 100;

                let hours = reservation.hours < 4 ? 4 : reservation.hours,
                    carPrices = {
                    TYPE_HOURS: hours * 1000,
                    TYPE_DAY: 10000,
                    TYPE_WEEKEND: 20000,
                };
                if (reservation.car) {
                    reservation.order.rows.push({
                        id: null,
                        name: 'Autonvuokraus ' + reservation.hours + 'h',
                        price: 5000
                    });

                    reservation.order.total += 5000;
                }

                if (reservation.staff) {
                    if (reservation.type !== 'TYPE_BUNDLE') {
                        let staffHours = reservation.hours > 4 ? 4 : reservation.hours;
                        reservation.order.rows.push({
                            id: null,
                            name: 'Henkilökunta ' + staffHours + 'h',
                            price: 10000
                        });

                        reservation.order.total += 10000;
                    }
                    this.vatPc = 10;
                } else {
                    this.vatPc = 24;
                }

                if (reservation.delivery && !reservation.staff) {
                    reservation.order.rows.push({
                        id: null,
                        name: 'Pallojen tuonti',
                        price: 5000
                    });

                    reservation.order.total += 5000;
                }
                if (reservation.pickUp && !reservation.staff) {
                    reservation.order.rows.push({
                        id: null,
                        name: 'Pallojen haku',
                        price: 5000
                    });

                    reservation.order.total += 5000;
                }

            }, (response) => {

                let errors = response.json();

                if (errors.errors) {
                    this.errors = errors;
                } else if (errors.message) {
                    this.errors = {errors: [{message: errors.message, propertyPath: 'check'}]};
                    // this.alerts.push({severity: 'error', summary: 'Virhe tallennuksessa', detail: errors.message});
                }

                console.log(errors);
            });
    }

    public order(reservation : IReservation, invoiceType : string) {
      if (!this.captcha.getResponse()) {
        this.errors = {errors: [{message: 'Klikkaa robottifiltteriä!', propertyPath: 'check'}]};
        return;
      }
        reservation.order.invoices = [];
        let copy = Object.assign({}, reservation);
        copy.order = Object.assign({}, copy.order);
        //this.addInvoice(copy, invoiceType);
        copy.startDate = copy.startDate && moment(copy.startDate).format('YYYY-MM-DD');
        copy.title = copy.order.rows[0].name;
        this.ReservationResource.save(copy)
            .$observable
            .subscribe((savedReservation : IReservation) => {
                savedReservation.startDate = savedReservation.startDate && moment(savedReservation.startDate).toDate();
                _.merge(reservation, savedReservation);
                this.errors = null;
                //this.sendInvoice();
              this.send(copy);
            }, (response) => {

                let errors = response.json();

                if (errors.errors) {
                    this.errors = errors;
                } else if (errors.message) {
                    // this.alerts.push({severity: 'error', summary: 'Virhe tallennuksessa', detail: errors.message});
                }

                console.log(errors);
            });
    }

    public staffChanged() {
        this.editingReservation.canReserve = false;
        if (this.editingReservation.staff) {
            this.checkboxMemory = {
                pickUp: this.editingReservation.pickUp,
                delivery: this.editingReservation.delivery,
                car: this.editingReservation.car,
            };
            this.editingReservation.pickUp = true;
            this.editingReservation.delivery = true;
            this.editingReservation.car = false;
        } else if (this.checkboxMemory) {
            this.editingReservation.pickUp = this.checkboxMemory.pickUp;
            this.editingReservation.delivery = this.checkboxMemory.delivery;
            this.editingReservation.car = this.checkboxMemory.car;
        }
    }

    private sendInvoice() {
        this.PaymentResource.sendInvoice(this.editingReservation.order.invoices[0])
            .$observable
            .subscribe((response : {paymentURL : string}) => {
                window.location.href = response.paymentURL;
            });
    }

    private addInvoice(reservation : IReservation, type : string) {
        let amount = Number(reservation.order.total);
        if (type === 'TYPE_PREPAYMENT') {
            amount *= .2;
            reservation.order.fullTotal = reservation.order.total;
            reservation.order.total = amount;
        }
        reservation.order.invoices.push({
            id          : null,
            type,
            amount,
            firstname   : reservation.reserver.firstname,
            lastname    : reservation.reserver.lastname,
            address     : reservation.reserver.address,
            zipCode     : reservation.reserver.zipCode,
            postOffice  : reservation.reserver.postOffice,
            rows        : reservation.order.rows,
            status      : 0,
            vatPc       : this.vatPc
        });
    }

  public send(order) {
    this.errors = null;
      this.ContactResource.order({order})
          .$observable
          .subscribe(() => {
            this.formSent = true;
          }, (response) => {

            let errors = response.json();

            if (errors.errors) {
              this.errors = errors;
            }
          });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/order/order.component.ts